module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 9.88 9.876\"><defs><style>.DatepickerControl-exitSvg{fill:#ccc;fill-rule:evenodd}</style></defs><path d=\"M9.89 8.473L8.474 9.887 4.94 6.352 1.403 9.887-.01 8.473l3.535-3.535L-.01 1.402 1.404-.012 4.94 3.524 8.474-.012 9.89 1.402 6.352 4.938 9.89 8.473z\" class=\"DatepickerControl-exitSvg\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./client/components/DatepickerControl/exit.svg
// module id = 2003
// module chunks = 0